// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nBRP","index":"styles_index__1XpbT"};